/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteConfigurationChargePointVnf$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected opcua configuration
 */
  opcuaUid: string;
}

export function deleteConfigurationChargePointVnf(http: HttpClient, rootUrl: string, params: DeleteConfigurationChargePointVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteConfigurationChargePointVnf.PATH, 'delete');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('opcuaUid', params.opcuaUid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteConfigurationChargePointVnf.PATH = '/custom/stations/{uid}/opcua/{opcuaUid}/configure';
